import React from "react";
import { Link } from "react-router-dom";

const Error404 = () => {
   return (
      <div className="authincation h-100">
         <div className="container vh-100">
            <div className="row justify-content-center h-100 align-items-center ">
               <div className="col-md-7">
                  <div className="form-input-content text-center error-page">
                     <h1 className="error-text font-weight-bold">404</h1>
                     <h4>
                        <i className="fa fa-exclamation-triangle text-warning" />{" "}
                      La pagina que estas buscando no esta disponible
                     </h4>
                     <p>
                      Selecciona otra opcion en el menu
                     </p>
                   
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default Error404;
